import { render, staticRenderFns } from "./TabMenuCom.vue?vue&type=template&id=740c271d&scoped=true"
import script from "./TabMenuCom.vue?vue&type=script&lang=js"
export * from "./TabMenuCom.vue?vue&type=script&lang=js"
import style0 from "./TabMenuCom.vue?vue&type=style&index=0&id=740c271d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c271d",
  null
  
)

export default component.exports